import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='order-routing-summary'
    backgroundVariant='lightA'
    themeType='lightTheme'
    disableBottomPadding>
    <Row align='center'>
      <Col medium={8}>
        <Typography component='h1'>
          Order Routing Summary
        </Typography>
        <Typography>
          In November 2000, the SEC adopted new rules aimed at improving the quality and availability of public disclosure related
          to order execution and routing practices. The SEC believes that the new rules will increase competition among market centers
          to provide the best possible price and speed of execution for investor orders. We welcome this opportunity to share with
          you our order routing practices.
        </Typography>
        <Typography>
          Data for orders cleared through Pershing, LLC can be found by going to&#160;
          <Link
            id='order-routing-summary-link'
            variant='primaryDeemphasize'
            linkUrl='https://www.orderroutingdisclosure.com'
            isOutgoingLink>
            order routing disclosure
          </Link>.
          &#160;and entering Northwestern Mutual as the name of the Broker&#45;Dealer.
        </Typography>
        <Typography>
          Clients may request more detailed execution information specific to their orders by contacting Northwestern Mutual Investment
          Services, LLC (NMIS) at&nbsp;
          <Link
            variant='primaryDeemphasize'
            linkUrl='tel:8666647737'>
            1&#45;866&#45;664&#45;7737
          </Link>.
        </Typography>
        <Typography>
          This site has been published in the United States for residents of the United States. The foregoing has been prepared solely
          for informational purposes and is not an offer to buy or sell or a solicitation of an offer to buy or sell any security
          or instrument or to participate in any particular trading strategy.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
